import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { KomitentUgovorStavka } from './komitent-ugovor-stavka';

@Component({
  selector: 'yt-komitent-ugovor-stavka-inline-update',
  templateUrl: './komitent-ugovor-stavka-inline-update.component.html'
})
export class KomitentUgovorStavkaInlineUpdateComponent extends BaseInlineUpdateComponent<KomitentUgovorStavka> {

  constructor(
    protected inlineContainerService: InlineContainerService<KomitentUgovorStavka>
  ) { 
    super(inlineContainerService)
  }

}
